import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { adminAuth } from "@/lib/adminAuth";
import { BrandHeader } from "@/components/BrandHeader";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const returnTo = params.get("returnTo") || "/admin";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const login = useMutation({
    mutationFn: () => adminAuth.login(email, password),
    onSuccess: () => navigate(returnTo, { replace: true }),
    onError: (e: any) => setError(e?.response?.data?.detail ?? "Login failed."),
  });

  return (
    <>
    <BrandHeader />
    <main className="grid min-h-[calc(100vh-80px)] place-items-center bg-brand-light p-6">
      <form
        className="card w-full max-w-sm p-8"
        onSubmit={(e) => { e.preventDefault(); login.mutate(); }}
      >
        <h1 className="text-2xl font-bold text-brand">Admin sign in</h1>
        <p className="mt-1 text-sm text-brand-ink/60">Enter your admin credentials.</p>

        <label className="field-label mt-6" htmlFor="email">Email</label>
        <input id="email" type="email" autoComplete="username" required
          className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} />

        <label className="field-label mt-4" htmlFor="password">Password</label>
        <input id="password" type="password" autoComplete="current-password" required
          className="field-input" value={password} onChange={(e) => setPassword(e.target.value)} />

        {error && <div role="alert" className="mt-3 text-sm text-brand">{error}</div>}

        <button type="submit" className="btn-primary mt-6 w-full justify-center"
          disabled={login.isPending}>
          {login.isPending ? "Signing in…" : "Sign in"}
        </button>

        <div className="mt-4 text-center text-sm">
          <Link to="/admin/forgot-password" className="text-brand hover:underline">
            Forgot password?
          </Link>
        </div>
      </form>
    </main>
    </>
  );
}
